import { faCopy, faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { observer } from "mobx-react-lite";

import { Button } from "src/base-components/Button";
import { Modal } from "src/design-system/Modal";

type ContinueEditingVersionModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  onDuplicateVersion: () => void;
  discardingSimulationsPending: boolean;
  onDiscardSimulations: () => void;
  flowVersionName: string;
};

export const ContinueEditingVersionModal: React.FC<ContinueEditingVersionModalProps> =
  observer(
    ({
      isOpen,
      closeModal,
      onDuplicateVersion,
      onDiscardSimulations,
      flowVersionName,
      discardingSimulationsPending,
    }) => {
      return (
        <>
          <Modal open={isOpen} size="sm" onClose={closeModal}>
            <Modal.Header>Continue editing {flowVersionName}?</Modal.Header>
            <Modal.Content>
              <div className="flex flex-col gap-y-5 text-gray-800 font-inter-normal-13px">
                <p>
                  To edit this version, you must discard all existing
                  simulations.
                  <br />
                  To preserve your results and make changes, click Duplicate
                  version.
                </p>
              </div>
            </Modal.Content>
            <Modal.Footer
              primaryButton={
                <Button
                  dataLoc="duplicate-flow"
                  htmlType="submit"
                  iconLeft={faCopy}
                  variant="primary"
                  onClick={onDuplicateVersion}
                >
                  Duplicate version
                </Button>
              }
              secondaryButton={
                <Button
                  dataLoc="delete-simulation"
                  htmlType="button"
                  iconLeft={faTrashAlt}
                  loading={discardingSimulationsPending}
                  variant="secondary"
                  onClick={onDiscardSimulations}
                >
                  Discard simulations
                </Button>
              }
            />
          </Modal>
        </>
      );
    },
  );
